export function clearable(schema) {
    return schema.nullable().optional();
}
//# sourceMappingURL=clearable.js.map